import http from './http';

export default {
  all() {
    return http().get(`/v1/campaign_cost_templates`);
  },
  get(id) {
    return http().get(`/v1/campaign_cost_templates/${id}`);
  },
  create(data) {
    return http().post(`/v1/campaign_cost_templates`, data);
  },
  update(data) {
    return http().put(`/v1/campaign_cost_templates/${data.id}`, data);
  },
  delete(id) {
    return http().delete(`/v1/campaign_cost_templates/${id}`);
  },
}
